export class REGEX {
  public static readonly SCI_NOTATION =
    /^[+\-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:\d[eE][+\-]?\d+)?$/;
  public static readonly SCI_NOTATION_POSITIVE =
    /^[+]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:\d[eE][+\-]?\d+)?$/;
  public static readonly SCI_NOTATION_NEGATIVE =
    /^[-](?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:\d[eE][+\-]?\d+)?$/;

  public static readonly FOR_MASK = {
    SCI_NOTATION: /^[+\-]?((?:0|[1-9]\d*)(?:\.\d*)?(?:[eE]([+\-])?(\d+)?)?)?$/,
    SCI_NOTATION_POSITIVE: /^[+]?((?:0|[1-9]\d*)(?:\.\d*)?(?:[eE]([+\-])?(\d+)?)?)?$/,
    SCI_NOTATION_NEGATIVE: /^[-]((?:0|[1-9]\d*)(?:\.\d*)?(?:[eE]([+\-])?(\d+)?)?)?$/,
  };

  public static readonly LOWERCASE = /[a-z]/g;
  public static readonly COF_LINE_BREAK = /\\r\\n|\r\n|\n|\r/g;
  public static readonly US_DATE =
    /^02\/(?:[01]\d|2\d)\/(?:19|20)(?:0[048]|[13579][26]|[2468][048])|(?:0[13578]|10|12)\/(?:[0-2]\d|3[01])\/(?:19|20)\d{2}|(?:0[469]|11)\/(?:[0-2]\d|30)\/(?:19|20)\d{2}|02\/(?:[0-1]\d|2[0-8])\/(?:19|20)\d{2}$/;
  public static readonly COF_LAYER =
    /([^\s]+)\s+(.+)\s+([0-9\.E\+\-]+)\s+(.+)\s+([0-9\.E\+\-]+)\s+([0-9\.E\+\-]+)\s+([0-9\.E\+\-]+)\s+([0-9\.E\+\-]+)/;
  public static readonly FIRST_DIGIT = /(^|\s)\S/g;
  public static readonly LABEL_RULES = /^[a-zA-Z0-9_.-]*$/;

  public static readonly CLIPBOARD_ROWS_DIVISORS = {
    WINDOWS: '\r\n',
    POSIX: '\n',
    MAC_POSIX: '\r',
  };
  public static readonly CLIPBOARD_COLS_DIVISOR = '\t';
}
